module.exports = __webpack_public_path__ + "static/fipcahoywhalemain-67e9ba70916ab0a74877b7a6e62c71e2.jpeg";